import { render, staticRenderFns } from "./EmailComposerV1.vue?vue&type=template&id=1f412a87&"
import script from "./EmailComposerV1.vue?vue&type=script&lang=js&"
export * from "./EmailComposerV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports